// Catalogue actif réactif (liveQuery), accès via le wrapper de scope tenant
// `withTenant` — jamais de table brute en composant (INV-C). Ordre d'affichage
// = ORDRE_CARTE (LOT 7c §5, positions stables) — l'alphabet est banni.
import { useLiveQuery } from 'dexie-react-hooks';
import { getDb } from '@/db';
import { withTenant } from '@/db/tenant';
import { ordonnerParCarte } from '@/lib/ordre-carte';
import { ORDRE_CARTE } from '@/config/ordre-carte.pizznco';
import type { Pizza } from '@/db/schema';

export function useCatalogue(): Pizza[] {
  const pizzas = useLiveQuery(
    async () => {
      const all = await withTenant(getDb().pizzas).toArray();
      return ordonnerParCarte(
        all.filter((p) => p.actif),
        ORDRE_CARTE,
      );
    },
    [],
    [] as Pizza[],
  );
  return pizzas;
}
